import { createContext } from 'react';

export type SettingsContextType = {
    basePath: string;
    redirectPath?: string;
    publicUrl: string;
    tokenUrl: string;
    apiUrl: string;
    recaptchaUrl: string;
    companyInfoId: number;
    detailPageViewMode: string;
    locationViewMode: string;
    messageViewMode: string;
    sendFlowersUrl?: string;
    useGoogleRecaptchaV3: boolean;
    useGoogleRecaptchaV3Enterprise: boolean;
    googleRecaptchaV3PublicKey?: string;
    loadDefaultFont: boolean;
    openExternalLinksInSameWindow: boolean;
};

const SettingsContext = createContext<SettingsContextType>({
    basePath: '/',
    publicUrl: window.location.href,
    tokenUrl: '',
    apiUrl: '',
    recaptchaUrl: '',
    companyInfoId: 1,
    detailPageViewMode: 'tabs',
    locationViewMode: 'grid',
    messageViewMode: 'grid',
    useGoogleRecaptchaV3: false,
    useGoogleRecaptchaV3Enterprise: false,
    loadDefaultFont: true,
    openExternalLinksInSameWindow: false,
});

export default SettingsContext;
